/**
 * Format a number to string with commas
 *
 * Usage:
 *  prettyFormatNumber(-8.676135282963514e-10) // "0"
 *  prettyFormatNumber(0) // "0"
 *  prettyFormatNumber(1234) // "1,234"
 */
export function prettyFormatNumber(number: number, precision: number): string {
  const precisionNumber = Math.pow(10, precision)
  // Takes care of the small scientific notation numbers
  const roundedNumber = Math.round(number * precisionNumber) / precisionNumber
  // Sometimes it outputs -0
  if (roundedNumber === 0) {
    return '0'
  }

  return roundedNumber.toLocaleString('en-US', {
    maximumFractionDigits: precision,
    minimumFractionDigits: 0,
  })
}
